'use strict';

module.exports = global.jQuery({});
